import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { FinanciacionPrivadaModel } from './financiacion-privada.model';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { FinanciacionPrivadaService } from './financiacion-privada.service';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { SharedService } from '../../../shared/services/shared.service';
import { FinanciacionPrivadaDialogImportAccount } from './financiacion-privada-dialog-importAccount.component';

@Component({
    selector: 'convfact-financiacion-privada-form',
    templateUrl: './financiacion-privada-form.component.html',
    styleUrls: ['./financiacion-privada.component.css'],
    standalone: false
})
export class FinanciacionPrivadaFormComponent implements OnInit {

  @Input() financiacionPrivada: FinanciacionPrivadaModel;
  @Output() onSave = new EventEmitter<any>();

  public loading = false;
  public ready = false;

  //AccountMovementes Import data
  flagImport = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //------------------------------

  public bankAccounts: BankAccountModel[] = [];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private financiacionPrivadaService: FinanciacionPrivadaService,
    @Optional() public dialogRef: MatDialogRef<AccountingMovementsImportComponent>,
    private bankAccountService: BankAccountService,
    private sharedService: SharedService,
    public dialog: MatDialog
  ) { }

  public ngOnInit(): void {
    this.ready = true;

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      });

    if (this.data !== null) {
      this.flagImport = true;
    }

    if (this.flagImport) {
      this.movement = this.data.movement;
      this.type = this.data.type;
      this.movement.type = this.type;
      this.financiacionPrivada.manualMovement = this.movement;
      this.financiacionPrivada.descripcion = this.movement.reference;

      //Largo plazo
      if (this.movement.accountNumber.startsWith("171")) {
        this.financiacionPrivada.duracion = 2;
        this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
          this.financiacionPrivada.accountingModelsLargoPlazoNumber = response;
          this.financiacionPrivada.manualMovement.accountNumber = response;
        })
      }

      //Corto plazo
      if (this.movement.accountNumber.startsWith("521")) {
        this.financiacionPrivada.duracion = 1;
        this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
          this.financiacionPrivada.accountingModelsCortoPlazoNumber = response;
          this.financiacionPrivada.manualMovement.accountNumber = response;
        })

      }

    }
  }

  public save(): void {
    this.loading = true;
    let noError = true;

    if (this.financiacionPrivada.descripcion == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Descripción' es requerido");
    }

    if (this.financiacionPrivada.importeInicial == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Importe inicial' es requerido");
    }

    if (this.financiacionPrivada.importePendiente == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Importe pendiente' es requerido");
    }

    if (this.financiacionPrivada.comisionApertura == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Comisión apertura' es requerido");
    }

    if (this.financiacionPrivada.fechaConstitucion == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de constitución' es requerido");
    }

    if (this.financiacionPrivada.plazo == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Plazo' es requerido");
    }

    if (this.financiacionPrivada.fechaFinalizacion == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de finalizacion' es requerido");
    }

    if (this.financiacionPrivada.tipoInteres == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Tipo de Intereses' es requerido");
    }

    if (this.financiacionPrivada.carencia == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Carencia' es requerido");
    }

    if (this.financiacionPrivada.tipoLiquidaciones == null || this.financiacionPrivada.tipoLiquidaciones === 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Tipos de liquidaciones' es requerido");
    }

    if (this.financiacionPrivada.bankAccountsUid == null || this.financiacionPrivada.bankAccountsUid === consts.EMPTY_GUID) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Cuenta de adeudo' es requerido");
    }

    this.setDefaultsValues();

    if (noError) {
      if (this.flagImport) {
        this.saveData(this.financiacionPrivada);
      } else {
        this.onSave.emit(this.financiacionPrivada);
        this.loading = false;
      }
    }
  }

  public saveData(financiacionPrivada: FinanciacionPrivadaModel): void {
    this.financiacionPrivadaService.add(financiacionPrivada)
      .then(response => {
        this.saved = true;
        this.closeDialog();
      },
        error => {
          //Si venimos de importar, y ya existe la financiación, preguntamos si queremos actualizar
          //la financiación ya existente
          if (error.error['message'].includes("ya se encuentra registrada") && this.flagImport) {
            this.dialog.open(FinanciacionPrivadaDialogImportAccount, {
              width: '20%',
              //height: '40%',
              data: {
                dataImport: financiacionPrivada,
              }
            }).afterClosed().subscribe(result => this.closeDialog())
          } else {
            this.displayInfo(error.error['message']);
          }
        }
      )
  }

  public closeDialog() {
    this.dialogRef.close(this.saved);
  }

  public setDefaultsValues(): void {
    // Valores por defecto en los campos que no sean requeridos
  }

  public setTipoDeLiquidacionesOptions(value: number) {
    this.financiacionPrivada.tipoLiquidaciones = value;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
